import { Component, OnInit, inject } from '@angular/core'

import { DIALOG_DATA, DialogRef, DialogService } from '@hyperkit'

@Component({
  standalone: false,
  selector: 'export-options-dialog',
  templateUrl: './export-options-dialog.component.html',
  styleUrls: ['./export-options-dialog.component.scss'],
})
export class ExportOptionsDialogComponent implements OnInit {
  dialogRef = inject(DialogRef)
  dialogService = inject(DialogService)
  exportOptions = inject<string[]>(DIALOG_DATA, { optional: true })

  public data: { text: string; items?: { text: string }[] }[] = [
    {
      text: 'Select all',
      items: [],
    },
  ]
  public nestedArchive = false
  public checkedKeys: string[] = []

  public ngOnInit(): void {
    this.exportOptions.forEach((option) => {
      this.data[0].items.push({ text: option })
    })
  }

  public onSubmit(): void {
    const indices = this.checkedKeys
      .filter((item) => item.includes('_'))
      .map((item) => {
        const parts = item.split('_')
        return parseInt(parts[parts.length - 1], 10)
      })
    // Use indices from checked keys to get selected export options
    const result = indices.map((index) => this.exportOptions[index])
    this.dialogRef.close(result)
  }

  public onCheckedKeysChange(checkedKeys: string[]): void {
    this.checkedKeys = checkedKeys
  }

  public onClose(): void {
    this.dialogRef.close()
  }
}
